import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MsgService } from '../share/msg/msg.service';
import { LogService } from '../share/log/log.service';
import * as MSG from '../share/msg/msg';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CONSTANT } from '../../constant/constant';
import { AutoActStateService } from '../auto-act/auto-act-state.service';
import { ErrorMessageInfo, HttpStatusCodes } from './http-status-codes';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  public static isAutoSignIn = false;
  public static isAutoSignOut = false;

  constructor(
    private msg: MsgService,
    private logServ: LogService,
    private autoActState: AutoActStateService,
  ) {}

  // HTTP通信のエラーハンドリング
  //  * AngularにてHTTP通信が実施された際、自動的に当Interceptorが実行され、エラーを捕捉する。
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
    .catch((error) => {
      // 自動サインイン・アウト中はエラーを画面表示しない(保持するトークン情報が非同期で変化する為、APIへの問い合わせタイミング次第では認証エラーになる。APIからのエラー自体は許容するが画面表示はさせないようにする。)
      if (ErrorInterceptor.isAutoSignIn || ErrorInterceptor.isAutoSignOut) {
        return Observable.throw(error);
      }

      // いただきます端末、食堂メニュー表示端末はinterceptorでエラーハンドリングせず、別serviceで実施する
      if (['/scan-card/itadakimasu', '/scan-card/no-rsv-scan-card', '/scan-card/scan-cafeteria', '/scan-card/self-regi', '/cafemenu-term/display-menu'].includes(location.pathname)) {
        return Observable.throw(error);
      }

      const errorMessageInfo: ErrorMessageInfo = HttpStatusCodes.getErrorMessageInfo(error);
      switch (errorMessageInfo.toasterType) {
        case 'error':
          this.msg.error(errorMessageInfo.message, '');
          break;
        case 'warning':
          this.msg.warning(errorMessageInfo.message, '');
          break;
        case 'important-warning':
          this.msg.warning(errorMessageInfo.message, '', 0);
          break;
        default:
          this.msg.error(errorMessageInfo.message, '', 0);
          break;
      }

      return Observable.throw(error);
    });
  }
}
